/* Order sheet: the floating bar's Order button opens a small sheet with the key choices (finish, care,
   custom design), the live total, and an Add to Order button. Nothing is duplicated: every control in the
   sheet clicks the matching control on the page, so variants, add-ons and the price total all use the page's
   own logic. The sheet's main button submits the real product form, which opens the cart drawer. */
(function () {
  const init = () => {
    const sheet = document.getElementById('OrderSheet');
    const openButton = document.querySelector('[data-order-open]');
    const mainAdd = document.querySelector('.product-form__submit[name="add"]');
    if (!sheet || !openButton) return;

    // Without the product form there is nothing to order here: keep the old behaviour.
    if (!mainAdd) {
      openButton.addEventListener('click', () => {
        if (typeof scrollToSection === 'function') scrollToSection('#product-overview');
      });
      return;
    }

    const bar = document.querySelector('.floating-cta-bar');
    const stepsRoot = sheet.querySelector('[data-order-steps]');
    const addButton = sheet.querySelector('[data-order-add]');
    const addPrice = sheet.querySelector('[data-order-price]');
    const pagePrice = document.querySelector('[data-cta-price]');

    const el = (tag, className, text) => {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text) node.textContent = text;
      return node;
    };

    /* ---- build the steps from the page's own controls ---- */
    const build = () => {
      stepsRoot.textContent = '';

      // Options (finish swatches, or pills for other options)
      document.querySelectorAll('variant-selects fieldset').forEach((fieldset) => {
        const inputs = [...fieldset.querySelectorAll('input[type="radio"]')];
        if (inputs.length < 2) return;
        const legend = fieldset.querySelector('legend');
        const name = legend ? legend.firstChild.textContent.replace(':', '').trim() : '';
        const step = el('section', 'order-sheet__step');
        const label = el('p', 'order-sheet__label type-caption-sm');
        label.append(name + ': ');
        const value = el('span', '');
        label.append(value);
        step.append(label);

        const row = el('div', 'order-sheet__options');
        inputs.forEach((input) => {
          const pageLabel = fieldset.querySelector('label[for="' + input.id + '"]');
          const swatch = pageLabel && pageLabel.querySelector('.swatch');
          const button = el('button', swatch ? 'order-sheet__swatch' : 'order-sheet__pill type-caption');
          button.type = 'button';
          button.title = input.value;
          button.dataset.inputId = input.id;
          if (swatch) {
            button.append(swatch.cloneNode(true));
            button.setAttribute('aria-label', input.value);
          } else {
            button.textContent = input.value;
          }
          button.addEventListener('click', () => input.click());
          row.append(button);
        });
        step.append(row);
        step.dataset.kind = 'option';
        stepsRoot.append(step);
      });

      // Winespot Care
      const cards = [...document.querySelectorAll('.ws-care-card')];
      if (cards.length) {
        const step = el('section', 'order-sheet__step');
        step.append(el('p', 'order-sheet__label type-caption-sm', 'Winespot Care'));
        cards.forEach((card) => {
          const row = el('button', 'order-sheet__care');
          row.type = 'button';
          row.dataset.careType = card.dataset.careType;
          row.append(el('span', 'order-sheet__radio'));
          const title = card.querySelector('.ws-care-text');
          row.append(el('span', 'order-sheet__care-name type-body-sm', title ? title.textContent.trim() : card.dataset.careType));
          const status = card.querySelector('.ws-care-card__status');
          row.append(el('span', 'order-sheet__care-status type-caption', status ? status.textContent.trim() : ''));
          row.addEventListener('click', () => card.click());
          step.append(row);
        });
        step.dataset.kind = 'care';
        stepsRoot.append(step);
      }

      // Custom design
      const designButton = document.querySelector('[data-qstomizer-open]');
      if (designButton) {
        const step = el('section', 'order-sheet__step order-sheet__step--design');
        step.append(el('p', 'order-sheet__label type-caption-sm', 'Custom design'));
        const row = el('div', 'order-sheet__design');
        const status = el('span', 'order-sheet__design-status type-body-sm');
        const action = el('button', 'ws-link-btn', designButton.textContent.trim());
        action.type = 'button';
        action.addEventListener('click', () => {
          close();
          designButton.click();
        });
        row.append(status, action);
        step.append(row);
        step.dataset.kind = 'design';
        stepsRoot.append(step);
      }
      sync();
    };

    /* ---- keep the sheet in step with the page ---- */
    const sync = () => {
      stepsRoot.querySelectorAll('.order-sheet__step[data-kind="option"]').forEach((step) => {
        step.querySelectorAll('[data-input-id]').forEach((button) => {
          const input = document.getElementById(button.dataset.inputId);
          const on = !!(input && input.checked);
          button.classList.toggle('is-selected', on);
          button.setAttribute('aria-pressed', on ? 'true' : 'false');
          if (on) step.querySelector('.order-sheet__label span').textContent = input.value;
        });
      });

      stepsRoot.querySelectorAll('.order-sheet__care').forEach((row) => {
        const card = document.querySelector('.ws-care-card[data-care-type="' + row.dataset.careType + '"]');
        const on = !!(card && card.classList.contains('is-selected'));
        row.classList.toggle('is-selected', on);
        row.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      const design = stepsRoot.querySelector('.order-sheet__design-status');
      if (design) {
        const selection = document.querySelector('[data-personalization-selection]');
        design.textContent = selection && !selection.hidden ? 'Design added' : 'None yet';
      }

      const soldOut = mainAdd.disabled;
      addButton.disabled = soldOut;
      addPrice.textContent = !soldOut && pagePrice && !pagePrice.hidden ? pagePrice.textContent : '';
      addPrice.hidden = !addPrice.textContent;
    };

    /* ---- open / close ---- */
    // the sheet sits on top of the bar, so it needs the bar's current height
    const place = () => {
      const barHeight = bar ? bar.getBoundingClientRect().height : 0;
      sheet.style.setProperty('--order-sheet-bottom', barHeight + 'px');
    };

    const open = () => {
      build();
      place();
      sheet.hidden = false;
      void sheet.offsetWidth; // flush layout so the open transition runs
      sheet.classList.add('is-open');
      openButton.setAttribute('aria-expanded', 'true');
      const first = sheet.querySelector('button:not([disabled])');
      if (first) first.focus({ preventScroll: true });
    };

    const close = () => {
      sheet.classList.remove('is-open');
      openButton.setAttribute('aria-expanded', 'false');
      setTimeout(() => {
        if (!sheet.classList.contains('is-open')) sheet.hidden = true;
      }, 320);
    };

    openButton.addEventListener('click', () => (sheet.classList.contains('is-open') ? close() : open()));
    sheet.querySelector('[data-order-close]').addEventListener('click', close);
    sheet.querySelector('[data-order-backdrop]').addEventListener('click', close);
    window.addEventListener('resize', () => sheet.classList.contains('is-open') && place());
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && sheet.classList.contains('is-open')) close();
    });

    addButton.addEventListener('click', () => {
      if (mainAdd.disabled) return;
      mainAdd.click(); // the real form: adds the configured product (and add-ons) and opens the cart drawer
      close();
    });

    // the page changes while the sheet is open: variant radios, care cards, design, price, sold out
    document.addEventListener('change', () => sheet.classList.contains('is-open') && sync());
    document.addEventListener('ws:configchange', () => sheet.classList.contains('is-open') && sync());
    if (pagePrice) new MutationObserver(() => sheet.classList.contains('is-open') && sync()).observe(pagePrice, { childList: true, attributes: true });
    new MutationObserver(() => sheet.classList.contains('is-open') && sync()).observe(mainAdd, { attributes: true, attributeFilter: ['disabled'] });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
